/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateStoreRequest,
  HttpValidationProblemDetails,
  StoreDetailDto,
  StoreSummaryDto,
  UpdateStoreRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List stores for a merchant.
 */
export const adminStoresGetAdminMerchantsMerchantIdGuidStores = (
  merchantId: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreSummaryDto[]>(
    { url: `/admin/merchants/${merchantId}/stores`, method: 'GET', signal },
    options,
  );
};

export const getAdminStoresGetAdminMerchantsMerchantIdGuidStoresQueryKey = (
  merchantId?: string,
) => {
  return [`/admin/merchants/${merchantId}/stores`] as const;
};

export const getAdminStoresGetAdminMerchantsMerchantIdGuidStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminStoresGetAdminMerchantsMerchantIdGuidStoresQueryKey(merchantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>
  > = ({ signal }) =>
    adminStoresGetAdminMerchantsMerchantIdGuidStores(merchantId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!merchantId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStoresGetAdminMerchantsMerchantIdGuidStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>
>;
export type AdminStoresGetAdminMerchantsMerchantIdGuidStoresQueryError = unknown;

export function useAdminStoresGetAdminMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
          TError,
          Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresGetAdminMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
          TError,
          Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresGetAdminMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List stores for a merchant.
 */

export function useAdminStoresGetAdminMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStoresGetAdminMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminStoresGetAdminMerchantsMerchantIdGuidStoresQueryOptions(
    merchantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a store under a merchant.
 */
export const adminStoresPostAdminMerchantsMerchantIdGuidStores = (
  merchantId: string,
  createStoreRequest: CreateStoreRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    {
      url: `/admin/merchants/${merchantId}/stores`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createStoreRequest,
      signal,
    },
    options,
  );
};

export const getAdminStoresPostAdminMerchantsMerchantIdGuidStoresMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStoresPostAdminMerchantsMerchantIdGuidStores>>,
    TError,
    { merchantId: string; data: CreateStoreRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStoresPostAdminMerchantsMerchantIdGuidStores>>,
  TError,
  { merchantId: string; data: CreateStoreRequest },
  TContext
> => {
  const mutationKey = ['adminStoresPostAdminMerchantsMerchantIdGuidStores'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStoresPostAdminMerchantsMerchantIdGuidStores>>,
    { merchantId: string; data: CreateStoreRequest }
  > = (props) => {
    const { merchantId, data } = props ?? {};

    return adminStoresPostAdminMerchantsMerchantIdGuidStores(merchantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresPostAdminMerchantsMerchantIdGuidStoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresPostAdminMerchantsMerchantIdGuidStores>>
>;
export type AdminStoresPostAdminMerchantsMerchantIdGuidStoresMutationBody = CreateStoreRequest;
export type AdminStoresPostAdminMerchantsMerchantIdGuidStoresMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Create a store under a merchant.
 */
export const useAdminStoresPostAdminMerchantsMerchantIdGuidStores = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminStoresPostAdminMerchantsMerchantIdGuidStores>>,
      TError,
      { merchantId: string; data: CreateStoreRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminStoresPostAdminMerchantsMerchantIdGuidStores>>,
  TError,
  { merchantId: string; data: CreateStoreRequest },
  TContext
> => {
  const mutationOptions =
    getAdminStoresPostAdminMerchantsMerchantIdGuidStoresMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminStoresGetAdminStoresIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>({ url: `/admin/stores/${id}`, method: 'GET', signal }, options);
};

export const getAdminStoresGetAdminStoresIdGuidQueryKey = (id?: string) => {
  return [`/admin/stores/${id}`] as const;
};

export const getAdminStoresGetAdminStoresIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminStoresGetAdminStoresIdGuidQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>> = ({
    signal,
  }) => adminStoresGetAdminStoresIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStoresGetAdminStoresIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>
>;
export type AdminStoresGetAdminStoresIdGuidQueryError = unknown;

export function useAdminStoresGetAdminStoresIdGuid<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresGetAdminStoresIdGuid<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresGetAdminStoresIdGuid<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminStoresGetAdminStoresIdGuid<
  TData = Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStoresGetAdminStoresIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminStoresGetAdminStoresIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminStoresPutAdminStoresIdGuid = (
  id: string,
  updateStoreRequest: UpdateStoreRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<StoreDetailDto>(
    {
      url: `/admin/stores/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateStoreRequest,
    },
    options,
  );
};

export const getAdminStoresPutAdminStoresIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStoresPutAdminStoresIdGuid>>,
    TError,
    { id: string; data: UpdateStoreRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStoresPutAdminStoresIdGuid>>,
  TError,
  { id: string; data: UpdateStoreRequest },
  TContext
> => {
  const mutationKey = ['adminStoresPutAdminStoresIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStoresPutAdminStoresIdGuid>>,
    { id: string; data: UpdateStoreRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminStoresPutAdminStoresIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresPutAdminStoresIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresPutAdminStoresIdGuid>>
>;
export type AdminStoresPutAdminStoresIdGuidMutationBody = UpdateStoreRequest;
export type AdminStoresPutAdminStoresIdGuidMutationError = HttpValidationProblemDetails;

export const useAdminStoresPutAdminStoresIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminStoresPutAdminStoresIdGuid>>,
      TError,
      { id: string; data: UpdateStoreRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminStoresPutAdminStoresIdGuid>>,
  TError,
  { id: string; data: UpdateStoreRequest },
  TContext
> => {
  const mutationOptions = getAdminStoresPutAdminStoresIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Permanently delete a store. Audit row retains the pre-delete snapshot.
 */
export const adminStoresDeleteAdminStoresIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>({ url: `/admin/stores/${id}`, method: 'DELETE' }, options);
};

export const getAdminStoresDeleteAdminStoresIdGuidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStoresDeleteAdminStoresIdGuid>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStoresDeleteAdminStoresIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminStoresDeleteAdminStoresIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStoresDeleteAdminStoresIdGuid>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminStoresDeleteAdminStoresIdGuid(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresDeleteAdminStoresIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresDeleteAdminStoresIdGuid>>
>;

export type AdminStoresDeleteAdminStoresIdGuidMutationError = unknown;

/**
 * @summary Permanently delete a store. Audit row retains the pre-delete snapshot.
 */
export const useAdminStoresDeleteAdminStoresIdGuid = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminStoresDeleteAdminStoresIdGuid>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminStoresDeleteAdminStoresIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminStoresDeleteAdminStoresIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminStoresPostAdminStoresIdGuidSuspend = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    { url: `/admin/stores/${id}/suspend`, method: 'POST', signal },
    options,
  );
};

export const getAdminStoresPostAdminStoresIdGuidSuspendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidSuspend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminStoresPostAdminStoresIdGuidSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidSuspend>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminStoresPostAdminStoresIdGuidSuspend(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresPostAdminStoresIdGuidSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidSuspend>>
>;

export type AdminStoresPostAdminStoresIdGuidSuspendMutationError = unknown;

export const useAdminStoresPostAdminStoresIdGuidSuspend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidSuspend>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminStoresPostAdminStoresIdGuidSuspendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminStoresPostAdminStoresIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    { url: `/admin/stores/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getAdminStoresPostAdminStoresIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminStoresPostAdminStoresIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminStoresPostAdminStoresIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresPostAdminStoresIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidActivate>>
>;

export type AdminStoresPostAdminStoresIdGuidActivateMutationError = unknown;

export const useAdminStoresPostAdminStoresIdGuidActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminStoresPostAdminStoresIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminStoresPostAdminStoresIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
